import { PortalDialogProps } from "@app/services/modal.service";
import { CreateWithdrawForm } from "@app/types";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useState } from "react";
import Modal from "../modal/modal.component";
import { FormControl } from "../form-control";
import Input from "../input";
import Button from "../button";
import { createWithdrawValidationSchema } from "@app/validations";
import { formatMoneyVN } from "@app/utils/util";
import { MIN_MONEY_WITHDRAW } from "@app/constants";

function WithdrawModal({ portalDialogRef }: PortalDialogProps) {
  const formRef = createRef<FormikContextType<CreateWithdrawForm>>();
  const [money, setMoney] = useState(0);

  const onSubmit = (withdraw: CreateWithdrawForm) => {
    if (!formRef.current) return;

    portalDialogRef.close({ withdraw });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">Rút tiền</div>
        <Formik
          innerRef={formRef}
          initialValues={{
            money: 0,
          }}
          onSubmit={onSubmit}
          validationSchema={createWithdrawValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <div>
              <div className="mt-7">Nhập số tiền cần rút</div>
              <FormControl name="money">
                <Input
                  className="mt-4"
                  onChange={(e) => setMoney(+e.target.value)}
                />
              </FormControl>
              {!!money && money >= MIN_MONEY_WITHDRAW && (
                <div className="text-xs">
                  Số tiền rút: {formatMoneyVN(money)}đ
                </div>
              )}
            </div>
            <div className="mt-11">
              <Button
                type="submit"
                size="xs"
                label="Xác nhận"
                width="100%"
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default WithdrawModal;
